import React from 'react';
import RadioButton from '../inputs/radio';

const LiveWithLandlord = (props) => (
  <section
    className="search-filter__section"
    role="group"
    aria-labelledby="landlord-preferences-title"
  >
    <div id="landlord-preferences-title" className="form-group__title">
      Live with landlord?
    </div>
    <div className="search-filter__radio-wrapper">
      <RadioButton
        name={'landlord'}
        id={'liveWithLandlord'}
        value={'live_in'}
        checked={props.data.landlord === 'live_in'}
        handleChange={(e) => props.updateInput('landlordOptions', e.target)}
        labelText={'Living with landlord'}
      />
      <RadioButton
        name={'landlord'}
        id={'notWithLandlord'}
        value={'live_out'}
        checked={props.data.landlord === 'live_out'}
        handleChange={(e) => props.updateInput('landlordOptions', e.target)}
        labelText={'Not living with landlord'}
      />
      <RadioButton
        name={'landlord'}
        id={'noLandlordPreference'}
        value={'dont_mind'}
        checked={props.data.landlord === 'dont_mind'}
        handleChange={(e) => props.updateInput('landlordOptions', e.target)}
        labelText={"Don't mind"}
      />
    </div>
  </section>
);

export default LiveWithLandlord;
